import React from 'react'

export default React.createClass({



render: function(){
  let edit;
    if(this.props.hideAllButtons !== true){
      edit = <a id='edit1' className='pull-down-xs-1' style={{float: 'right', textDecoration: 'underline'}} onClick={this.props.openUpgradeFrequencyModal}>Edit</a>
    }
  return (
      <div className='row'>
        <hr style={{borderColor: '#c7c7c7', marginRight: -15, marginLeft: -15}}/>
        <div className='col-xs-12'>
          <div style={{fontSize: 24}}>
            <b className='pull-left'>Service Frequency: </b>
            <div className='pull-left' style={{paddingLeft: 10}}>{this.props.name}</div>
          </div>
          {edit}
        </div>
      </div>
    )
  }
})


// WEBPACK FOOTER //
// ./src/components/modals/components/service-frequency.jsx